import pkg from '../../package.json';

export const PACKAGE_NAME: string = pkg.name;
export const PACKAGE_VERSION: string = pkg.version;
export const PRODUCTION: boolean = process.env.NODE_ENV === 'production';
export const API_PREFIX: string = '/backend/api';
export const ASSET_PREFIX: string = '/asset';
